import { autoinject, bindable, customAttribute } from 'aurelia-framework';
import { HtmlDrop, IDroppableHandler } from './models';

@autoinject
@customAttribute('droppable')
export class Droppable extends HtmlDrop {
	@bindable handler: IDroppableHandler;
	@bindable target: any;

	constructor(private element: Element) {
		super();
	}

	attached() {
		this.bindDropEvents(this.element);
	}

	onDragEnter(event: DragEvent): void {
		this.handler.onDragEnter(event, this.target);
	}

	onDragLeave(event: DragEvent): void {
		this.handler.onDragLeave(event, this.target);
	}

	onDrop(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		this.handler.onDrop(event, this.target);
	}
}
